import React, { Component } from "react";
import { Flex, Elastic, MyCampo, Mycard, colors, Transition } from "../ui";
import {Btn} from "./../UI-Components/Btn";
import { FooterFactura } from "../pagaFactura";
import styled from "@emotion/styled";
import { withRouter } from "react-router";
import { serialize, valueOrDashes } from "./helper";

import TemplatePDF, { savePDF } from "./TemplatePDF";

/** @jsx jsx */
import {jsx, css} from '@emotion/core';
import {
	parseJwt,
	serviceApiGet,
	serviceApiPost,
	serviceApiResponse
} from "../ServiciosMaestros/request";
import SimpleReactValidator from "simple-react-validator";
import { DataBlock, Toast, TextsStates } from "./helper";
import Script from "react-load-script";

import {fetch as fetchPolyfill} from "whatwg-fetch";
import {api} from "../ServiciosMaestros/apis";


const Alert = styled.div`
	width: 100%;
	background-color: ${props => colors[props.alert]};
	color: white;
	font-size: 25px;
	line-height: 50px;
	font-weight: 300;
	text-align: center;
	border-radius: 4px;
`;

const ShowOptions = ({
	email,
	loading,
	value,
	show,
	downloadPdf,
	print,
	onChangeInputText,
	sendEmail,
	loadingEmail,
	showPayment,
	loadingPayment,
	enviado = false,
	error = "",
	payment,
	payDebit,
	isDebit,
	isExist
}) => {

	return (
		<Flex className={"wc"} alg={"flex-end"}>

			{
			isDebit && payDebit !=="Aceptada"
			&& payDebit!=="Pendiente"
			&& !isExist
			&&
			<Btn
			className={"mb-3" }
			hg={"45"}
			loading={loadingPayment}
			disabled={loading|| loadingEmail || loadingPayment  }
			onClick={() => payment()}
			>
			{loadingPayment  ? "" : payDebit=="Rechazada"?"Reintentar Pago": "Realizar pago"}
			</Btn>

			}

			<Flex alg={"flex-end"} className={"col-12 col-md-6 px-0 pb-3 pb-md-0"}>
				<Flex elastic={"1 0 60%"}>
					<MyCampo
						value={value}
						type={"text"}
						name={"textEmail"}
						label={
							enviado
								? "¡Correo enviado exitosamente! "
								: "Enviar una copia al email"
						}
						disabled={loading || loadingEmail || loadingPayment}
						placeholder={"Ingrese su email"}
						onchange={e => onChangeInputText(e)}
						enviado={enviado}
						error={error}
					className={"p-0 pr-2"}/>
				</Flex>
				<Flex
					elastic={"0 0 35%"}
					className="px-0 pt-3 pt-sm-0 pl-sm-2 pr-sm-3"
					style={{ lineHeight: "0px" }}
				>
					<Btn
						hg={"45"}
						loading={loadingEmail}
						disabled={loading || loadingEmail || loadingPayment}
						onClick={() => sendEmail()}
					>
						{loadingEmail ? "" : "Enviar"}
					</Btn>
				</Flex>
			</Flex>

			<Flex className={"col-12 col-md-6 px-0"} jc={"flex-end"}>
				<div className="col-12 col-sm-6 pb-3 pb-sm-0 px-0 pr-sm-2">
					<Btn
						bg
						hg={"45"}
						onClick={() => print()}
						disabled={loading || loadingEmail || loadingPayment}
					>
						<img
							src="https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/print.png"
							alt=""
							className={"mr-2"}
						/>
						Imprimir
					</Btn>
				</div>
				<div className="col-12 col-sm-6 px-0 pl-sm-2 ">
					<Btn
						bg
						hg={"45"}
						onClick={downloadPdf}
						disabled={loading || loadingEmail || loadingPayment}
						loading={loading}
					>
						<img
							src="https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/download.png"
							alt=""
							className={`mr-2`}
						/>
						{loading ? "" : "Descargar"}
					</Btn>
				</div>

			</Flex>

		</Flex>
	);
};

let ruta = {};

class RespuestaSuscripcion extends Component {

	constructor(props) {
		super(props);

		this.validator = new SimpleReactValidator({
			messages: {
				required: "Debe ingresar un :attribute",
				regex: "Debe ingresar una dirección de :attribute válida"
			}
		});
	}

	state = {
    	autoEmail: false,
		loading: false,
		loadingR: false,
		loadingEmail: false,
		loadingPayment: false,
		showPayment: false,
		responseCheckoutPago: {},
		informacionEmpresa: {},
		response: {},
		email: false,
		textEmail: "",
		errorPago: false,
		printState: false,
		infoFactura: [],
		infoCabecera: {},
		infoEmpresa: {},
		total: 0,
		iva: 0,
		moneda: "COP",
		enviado: false,
		error: "",
		param: {
			option: "",
			referencia: ""
		},
		facturas: [],
		abonos: [],
		opcionPago: [],
		responseFactura: {},
		rutas: {},
		isDebit:false
	};

	componentWillMount() {

		let ref_payco = this.props.location.search && this.props.history.location.search.split("=")[1];
		ref_payco&&this.respuestaCheckoutPago(ref_payco);
		ruta = JSON.parse(sessionStorage.getItem("rutas"));
		const empresa = JSON.parse(sessionStorage.getItem("informacion"));
		const DataResponse = JSON.parse(
			sessionStorage.getItem("responseSubscription")
		);

		this.setState({ rutas: ruta });
		const data =
			this.props.responseInfo || sessionStorage.getItem("responseInfo");
		if (!data) {
			this.props.history.push(ruta.home);
		}
		else {
			this.setState({
				// responseFactura: JSON.parse(data).data,
				isDebit: DataResponse.data.isDebit,
				emailClient: DataResponse.data.email,
				responseFactura: DataResponse.data,
				infoEmpresa: empresa,
				isExist: DataResponse.data.cardCustomerExist
			});

			setTimeout(() => {
				let count=parseInt(DataResponse.data.countEmail);
				if(count === 0){
					sessionStorage.setItem(
						"responseSubscription",
						JSON.stringify({data:{...DataResponse.data, countEmail:count+1}})
					  );
					if(!DataResponse.data.isDebit){
						this.sendEmailCredit();
					}
				}

			}, 1500);
		}


	}

	async payment(){

		this.setState({ loadingPayment: true });
		const responseFactura = this.state.responseFactura;
		// const infoEmpresa = this.state.infoEmpresa;
		const datosFactura = responseFactura.responseFactura;
		const valorRecaudo = (datosFactura.filter(fac => fac.name.toLowerCase().includes("recaudo"))[0].value);
        let total = parseFloat(valorRecaudo);
		let subtotal = total - parseFloat(this.state.iva);
		let confirmUrl = process.env.REACT_APP_URL_CONFIRMACION;

        let responseUrl = `${window.location.protocol}//${window.location.hostname}${ruta.respuestaSuscripcion}`;
        if (process.env.REACT_APP_SERVER_RESPONSE === "true") {
            responseUrl = `${process.env.REACT_APP_SERVER}${ruta.respuestaSuscripcion}`;
		}
		let idFactura = responseFactura.responseTransaction.referencia;
        let data = {
            //Parametros compra (obligatorio)
            name: this.state.responseFactura.detalleSuscripcion.nombreSuscripcion || "factura",
            description: this.state.responseFactura.detalleSuscripcion.nombreSuscripcion || "factura",
            invoice: String(idFactura),
            currency: "cop",
            amount: String(total),
            tax_base: String(subtotal),
            tax: String(total-subtotal),
            country: "co",
            lang: "es",

            //Onpage="false" - Standard="true"
            external: "false",


            //Atributos opcionales
            // extra1: "extra1",
            // extra2: "extra2",
            // extra3: "extra3",
            extra9:"web",
            extra10:String(`id:${idFactura}:valor:${total}`),
            confirmation: confirmUrl,
            response: responseUrl,

            //Atributos cliente
            // name_billing: "Andres Perez",
            // address_billing: "Carrera 19 numero 14 91",
            // type_doc_billing: "cc",
            // mobilephone_billing: "3050000000",
            // number_doc_billing: "100000000"
        };

			window.ePayco.checkout.configure({
				key: parseJwt(),
				test: sessionStorage.getItem('test')
			})
			window.ePayco.checkout.onCloseModal= ()=>this.setState({ loadingPayment: false });
			window.ePayco.checkout.open(data);

	}


	respuestaCheckoutPago (ref_payco) {

		this.setState({chargingResponseCheckoutPago:true})
		this.setState({isDebit:true})
		let url = process.env.REACT_APP_SECURE + ref_payco;
			fetchPolyfill(url)
				.then((response) => {
					return response.json();
				})
				.then(response => {
					if (response.success) {
						this.setState({
							responseCheckoutPago: response.data
						})
						this.actualizarFactura(response.data);
					}
				});

	}

	actualizarFactura(data){
		serviceApiResponse({data},api.actualizarFacturaConfirmacion,"POST");
	}

	async downloadPdf() {
		this.setState({ loading: true });
		const subscriptionStatus = this.state.responseFactura.state
			? this.state.responseFactura.state
			: "";
		await savePDF(
			<TemplatePDF
				subscriptionPDFData={this.state.responseFactura}
				infoEmpresa={this.state.infoEmpresa}
				subscriptionStatus={subscriptionStatus}
				message={
					this.state.responseFactura.responseTransaction !== null
						? TextsStates["paymentAndSuscription"][
								subscriptionStatus.toLowerCase()
						  ]
						: TextsStates["suscription"][subscriptionStatus.toLowerCase()]
				}
			/>,
			`${this.state.responseFactura.detalleSuscripcion.nombreSuscripcion}.pdf`
		);
		this.setState({ loading: false });
	}

	print() {
		this.setState({ printState: true }, () => {
			window.print();
			setTimeout(() => {
				this.setState({ printState: false });
			}, 100);
		});
	}

	componentWillMount() {
		let ref_payco = this.props.location.search && this.props.history.location.search.split("=")[1];

		ref_payco&&this.respuestaCheckoutPago(ref_payco);
		ruta = JSON.parse(sessionStorage.getItem("rutas"));
		const empresa = JSON.parse(sessionStorage.getItem("informacion"));
		const DataResponse = JSON.parse(
			sessionStorage.getItem("responseSubscription")
		);

		// Aqui agrego el correo de la empresa para informar que fue rechazada el pago TDC sin fondo
		this.setState({textEmail:empresa.correo_empresa});
		/////////////////////////////////////////////////////

		this.setState({ rutas: ruta });
		const data =
			this.props.responseInfo || sessionStorage.getItem("responseInfo");
		if (!data) {
			this.props.history.push(ruta.home);
		}
		else {
			this.setState({
				// responseFactura: JSON.parse(data).data,
				isDebit: DataResponse.data.isDebit,
				emailClient: DataResponse.data.email,
				responseFactura: DataResponse.data,
				infoEmpresa: empresa,
				isExist: DataResponse.data.cardCustomerExist
			});


			setTimeout(() => {
				let count=parseInt(DataResponse.data.countEmail);
				if(count === 0){
					sessionStorage.setItem(
						"responseSubscription",
						JSON.stringify({data:{...DataResponse.data, countEmail:count+1}})
					  );
					if(DataResponse.data.isDebit){
						this.sendEmailDebit();
					}else{
						this.sendEmailCredit();
					}
				}
				// Coloco el metodo sendEmail para enviar el correo si esta rechazada
				this.sendEmail();

			}, 1500);
		}


	}

	sendEmail() {
		const { textEmail } = this.state;
		if (this.validator.allValid()) {
			this.validator.hideMessages();
			this.setState({ loadingEmail: true });

			const subscriptionStatus = this.state.responseFactura.state
				? this.state.responseFactura.state
				: "";
			const message = this.state.responseFactura.responseTransaction !== null
				? TextsStates["paymentAndSuscription"][
						subscriptionStatus.toLowerCase()
					]
				: TextsStates["suscription"][subscriptionStatus.toLowerCase()]
			const subscriptionData = this.state.responseFactura;
			const { infoEmpresa } = this.state;
			const factura = subscriptionData.responseFactura.map(factura =>
				factura.type === "money"
					? {...factura, value: `$${factura.value.toFixed(2)} COP`}
					: factura
			);
			const urlReintento = window.location.href.split("/").slice(0, -1).join("/");

			const viewParameters = {
				viewParameters: {
					nombreEmpresa: valueOrDashes(infoEmpresa.nombreEmpresa),
					estado: subscriptionStatus,
					logo: infoEmpresa.logoComercio,
					nit: valueOrDashes(infoEmpresa.nit),
					factura,
					nombreSuscripcion: valueOrDashes(subscriptionData.detalleSuscripcion.nombreSuscripcion),
					numeroSuscripcion: valueOrDashes(subscriptionData.detalleSuscripcion.numeroSuscripcion),
					medioPago: valueOrDashes(subscriptionData.detalleSuscripcion.medioPago),
					formaCobro: valueOrDashes(subscriptionData.detalleSuscripcion.formaCobro),
					proximoCobro: valueOrDashes(subscriptionData.detalleSuscripcion.proximoCobro),
					message: valueOrDashes(message),
					transaccion: subscriptionData.responseTransaction,
					urlReintento
				}
			}

			const subject = `${message ? message : "Resultado de suscripción"} en ePayco`;
			const viewName = "ResultadoDeSuscripcion";

			const url = `${process.env.REACT_APP_ROUTE_EMAIL}?subject=${subject}&viewName=${viewName}&toEmail=${textEmail}&${serialize(viewParameters)}`;
			serviceApiGet(
				url,
			).then(result => {
					const data = result;
					if (data.sentEmails) {
						this.setState({ enviado: true, textEmail: "" }, () => {
							setTimeout(() => {
								this.setState({ error: "", enviado: false });
							}, 5000);
						});
					} else {
						this.setState(
							{ error: "Hubo un error al enviar el correo." },
							() => {
								setTimeout(() => {
									this.setState({ error: "", enviado: false });
								}, 5000);
							}
						);
					}
					this.setState({ loadingEmail: false });
				})
				.catch(error => {
					this.setState({ error: "Hubo un error al enviar el correo." }, () => {
						setTimeout(() => {
							this.setState({ error: "" });
						}, 5000);
					});
					this.setState({ loadingEmail: false });
				});
		} else {
			this.validator.showMessages();
			this.forceUpdate();
		}
	}

	sendEmailDebit(){

		const debit = true;

		const subscriptionData = this.state.responseFactura;
		const { infoEmpresa } = this.state;


		const factura = subscriptionData.responseFactura.map(factura =>
			factura.type === "money"
				? {...factura, value: `$${factura.value.toFixed(2)} COP`}
				: factura
		);
		const numFactura = (factura.filter(fac => fac.name.toLowerCase()==="número de factura")[0]?.value);
		const refFactura = (factura.filter(fac => fac.name.toLowerCase()==="referencia de pago")[0]);
		let fac = refFactura ? refFactura.value : '';
		let option1 = 1;
		// const fac = numFactura ? numFactura : refFactura;
		// let option1 = numFactura ? 2 : 1;
		if(numFactura && !refFactura) {
			option1 = 2;
			fac = numFactura;
		}
		let urlReintento = window.location.href.split("/").slice(0, -1).join("/");
		urlReintento += `?option1=${option1}&value1=${fac}&checkout=true&debit=${debit}`;
		const sendEmailResponse = (viewName, emailParameters, emailCustomer) => {
			let viewParameters = '';
			Object.entries(emailParameters).forEach(([key, value]) => {
				viewParameters += `&viewParameters[${key}]=${value}`;
			});

			const subject = `${emailParameters.titulo ? emailParameters.titulo : "Resultado de suscripción"} en ePayco`;

			serviceApiGet(
				`${process.env.REACT_APP_ROUTE_EMAIL}?subject=${subject
				}&toEmail=${emailCustomer
				}&viewName=${viewName}&viewParameters=${viewParameters}`,
			);
		}

		let emailParameters ={}
		const stateCheckoutPago = this.state.responseCheckoutPago.x_response;
		let title=this.state.isExist?"SUSCRIPCIÓN ACTIVA Y CUENTA DÉBITO ACTIVA":TextsStates.paymentAndSuscriptionDebit["Pendiente"].text
		serviceApiPost(
			`${process.env.REACT_APP_API_URL}/api/suscripciones/detalle/suscripcion`,
			{
				public_key:subscriptionData.publicKey,
				suscripcionId:subscriptionData.detalleSuscripcion.numeroSuscripcion.toString()
			}
		)
		.then((data)=>{
			if(data.success){
					emailParameters =  {
						//header
						logo: infoEmpresa.logoComercio,
						titulo: title,
						estado: this.state.isExist?"Aceptada":stateCheckoutPago?stateCheckoutPago:"Pendiente",
						//detalle comercio
						nombreEmpresa: infoEmpresa.nombreEmpresa,
						nit: infoEmpresa.nit || '',
						//detalle medio de pago
						metodoPago:"Debito Bancario",
						tipoCuenta:subscriptionData.tipoCuenta,
						banco:subscriptionData.banco?subscriptionData.banco:"",
						numeroCuenta: subscriptionData.numeroCuenta,
						//detalle suscripcion
						nombreSuscripcion:subscriptionData.detalleSuscripcion.nombreSuscripcion,
						numeroSuscripcion:subscriptionData.detalleSuscripcion.numeroSuscripcion,
						medioDePago: `${subscriptionData.banco} ${subscriptionData.numeroCuenta}`,
						formaDeCobro: data.data.suscripcionInfo.fecha_cobro || '',
						proximaFechaDeCobro: data.data.suscripcionInfo.fecha_proximo_cobro || '',
						//detalle facturacion
						tipoDoc:data.data.clienteInfo.tipo_identificacion,
						numeroDoc:data.data.clienteInfo.numero_identificacion,
						direccion:data.data.clienteInfo.direccion,
						ciudad:data.data.clienteInfo.departamento,
						celular:data.data.clienteInfo.celular,
						urlReintento : this.state.isExist?"":`${encodeURIComponent(urlReintento)}`
					}
					sendEmailResponse("ResultadoDeSuscripcionDebit",emailParameters,data.data.clienteInfo.email);
				}
			}
		)
	}

	onChangeInputText(e) {
		let value = e.target.value;
		let name = e.target.name;
		this.setState({
			[name]: value
		});
	}

  async sendEmailCredit() {
		const {responseFactura } = this.state
		const email = responseFactura.email;
		const subscriptionStatus = this.state.responseFactura.state
		? this.state.responseFactura.state
		: "";
		const message = this.state.responseFactura.responseTransaction !== null
			? TextsStates["paymentAndSuscription"][
					subscriptionStatus.toLowerCase()
				]
			: TextsStates["suscription"][subscriptionStatus.toLowerCase()]
		const subscriptionData = this.state.responseFactura;
		const { infoEmpresa } = this.state;
		const factura = subscriptionData.responseFactura.map(factura =>
			factura.type === "money"
				? {...factura, value: `$${factura.value.toFixed(2)} COP`}
				: factura
		);
		const urlReintento = window.location.href.split("/").slice(0, -1).join("/");

		const viewParameters = {
			viewParameters: {
				nombreEmpresa: valueOrDashes(infoEmpresa.nombreEmpresa),
				estado: subscriptionStatus,
				logo: infoEmpresa.logoComercio,
				nit: valueOrDashes(infoEmpresa.nit),
				factura,
				nombreSuscripcion: valueOrDashes(subscriptionData.detalleSuscripcion.nombreSuscripcion),
				numeroSuscripcion: valueOrDashes(subscriptionData.detalleSuscripcion.numeroSuscripcion),
				medioPago: valueOrDashes(subscriptionData.detalleSuscripcion.medioPago),
				formaCobro: valueOrDashes(subscriptionData.detalleSuscripcion.formaCobro),
				proximoCobro: valueOrDashes(subscriptionData.detalleSuscripcion.proximoCobro),
				message: valueOrDashes(message),
				transaccion: subscriptionData.responseTransaction,
				urlReintento,
			}
		}

		const subject = `${message ? message : "Resultado de suscripción"} en ePayco`;
		const viewName = "ResultadoDeSuscripcion";

		const url = `${process.env.REACT_APP_ROUTE_EMAIL}?subject=${subject}&viewName=${viewName}&toEmail=${email}&${serialize(viewParameters)}`;
		serviceApiGet(
			url,
		);
  }

	async handleScriptLoad() {
		let dataCheckout = JSON.parse(sessionStorage.getItem("dataCheckout"));
		this.state.epayco.open({
			createOrder: () => {
				return window.ePayco2.checkout.signature({
					data: dataCheckout
				});
			},
			onChangeState: ({ button }) => {
				const { element, isSubscription } = button;
				if (isSubscription) element.innerHTML = "Administrar suscripción";
			},
			onCloseModal: () => {
				this.setState({ loadingSuscripciones: false, loadingR: false });
			},
			onFinish: data => {
				if (data.data) {
					sessionStorage.setItem("responseSubscription", JSON.stringify(data));
					this.props.history.push(`${ruta.respuestaSuscripcion}`);
				}
			},
			selector: "#open-checkout"
		});
	}
	componentWillReceiveProps(nextProps, nextContext) {
		if (Object.keys(nextProps).length > 0 && nextProps.info) {
			this.setState({
				infoEmpresa: nextProps.info
			});
		}
	}

	render() {
		const { state } = this.state.responseFactura;
		const stateCheckoutPago = this.state.responseCheckoutPago.x_response;
		let estados = {
			Pendiente: {
				text: "Suscripción pendiente por ser aprobada",
				color: "alertY"
			},
			Aceptada: {
				text: "Suscripción Aprobada",
				color: "alertG"
			},
			Rechazada: {
				text: "Suscripción Rechazada",
				color: "alertR"
			},
			Fallida: {
				text: "Suscripción Rechazada",
				color: "alertR"
			}
		};

		return (
			<Elastic
				felx={"1 0 auto"}
				className={"wc cambio"}
				css={css`
					animation: ${Transition} 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 1;
				`}
			>
				<Mycard
					visible={!this.state.printState}
					back={this.state.rutas.home}
					title={this.state.responseFactura.title || ""}
					className={" col-12 col-lg-10 mx-auto px-0"}
					footer={this.state.infoEmpresa.mostrarDatos == 1 && 
						<FooterFactura info={{
							correo_empresa: this.state.infoEmpresa.correo_empresa,
							tipoTelefonoValue: this.state.infoEmpresa.indicativoPais
								? "cel"
								: "fijo",
							valueIndicativo: this.state.infoEmpresa.valueIndicativo,
							indicativoPais: this.state.infoEmpresa.indicativoPais,
							tel_empresa: this.state.infoEmpresa.tel_empresa
						}}/>
					}
					history={this.props.history}
				>
					<div className="wc px-3">
						<div className="col-12 px-0">
							{this.state.responseFactura.state && !this.state.isDebit && (
								<Alert alert={estados[state].color} className={"mb-3"}>
									{this.state.responseFactura.responseTransaction
										? TextsStates["paymentAndSuscription"][
												this.state.responseFactura.state.toLowerCase()
										  ]
										: TextsStates["suscription"][
												this.state.responseFactura.state.toLowerCase()
										  ]}

									{/*{estados[state].text}*/}
								</Alert>
							)}
							{/* para un pago desde Realizar pago */}
							{ this.state.isDebit  && !this.state.isExist && (
								<Alert
								alert={
									stateCheckoutPago?
									TextsStates.paymentAndSuscriptionDebit[stateCheckoutPago].color
									:
									TextsStates.paymentAndSuscriptionDebit.Pendiente.color
								}
								className={"mb-3"}>
									{
									stateCheckoutPago?
									TextsStates.paymentAndSuscriptionDebit[stateCheckoutPago].text
									:
									TextsStates.paymentAndSuscriptionDebit.Pendiente.text
									}
								</Alert>
							)}
							{ this.state.isDebit  && this.state.isExist && (
								<Alert
								alert={
									estados.Aceptada.color
								}
								className={"mb-3"}>
									SUSCRIPCIÓN ACTIVA
								</Alert>
							)}

						</div>

						{(state === "Pendiente" || this.state.isDebit) && !this.state.isExist && (
							<div className="wc pb-2">
								<Toast
									type={"info"}
									mensaje={
										"Su suscripción está pendiente de activación, se le enviará un correo tan pronto se apruebe o se rechace."
									}
								/>
							</div>
						)}

						<Flex
							className={"wc pb-3"}
							style={{
								alignItems: "start"
							}}
						>
							<DataBlock
								title={"Detallle de la factura suscrita"}
								data={this.state.responseFactura.responseFactura}
							/>

							<DataBlock
								title={"Detalle de suscripción"}
								data={[
									{
										name: "Nombre suscripción",
										value: this.state.responseFactura.detalleSuscripcion
                      .nombreSuscripcion
									},
									{
										name: "Número suscripción",
										value: this.state.responseFactura.detalleSuscripcion
											.numeroSuscripcion
									},
									{
										name: "Medio de pago",
										value:
											this.state.responseFactura.medioPago &&
											this.state.responseFactura.medioPago.slice(-8)
									},
									{
										name: "Forma  de cobro",
										value: this.state.responseFactura.detalleSuscripcion
											.formaCobro
									},
									{
										name: "Próxima fecha de cobro",
										value: this.state.responseFactura.detalleSuscripcion
											.proximoCobro,
										noline: true
									}
								]}
							/>

							{/* CUANDO HAYA UN PAGO ? SUSCRIPCION CREDITO : SUSCRIPCION DEBITO */}
							{ !this.state.isDebit ? (this.state.responseFactura.responseTransaction !== null) &&
								<DataBlock
									title={"Detalle de pago"}
									data={[
										{
											name: "Referencia",
											value: this.state.responseFactura.responseTransaction
												.referencia
										},
										{
											name: "Ref. ePayco",
											value: this.state.responseFactura.responseTransaction
												.refPayco
										},
										{
											name: "IP origen",
											value: this.state.responseFactura.responseTransaction
												.ipOrigen
										},
										{
											name: "Método de pago",
											value:
												this.state.responseFactura.responseTransaction
													.metodoPago &&
												this.state.responseFactura.responseTransaction.metodoPago.slice(
													-8
												)
										},
										{
											name: "Número de recibo",
											value: this.state.responseFactura.responseTransaction
												.numeroRecibo
										},
										{
											name: "Total pagado",
											value: this.state.responseFactura.responseTransaction
												.total,
											noline: true
										}
									]}
								/>
									: this.state.responseCheckoutPago?.x_response ==="Aceptada" &&
									<DataBlock
									title={"Detalle de pago"}
									data={[
										{
											name: "Nombre",
											value: this.state.responseCheckoutPago.x_customer_name
										},
										{
											name: "Documento",
											value: this.state.responseCheckoutPago.x_customer_document
										},

										{
											name: "Medio de pago",
											value: this.state.responseCheckoutPago?.x_cardnumber.slice(-6)

										},
										{
											name: "Total pago",
											value: `${this.state.responseCheckoutPago.x_amount_ok} ${this.state.responseCheckoutPago.x_currency_code}`,
											noline: true
										}
									]}
								/>
							}


						</Flex>

						{this.state.responseFactura.state === "Rechazada" || this.state.responseFactura.state === "Fallida" && (
							<Flex className="wc pb-3">
								<Script
									url={process.env.REACT_APP_SCRIPT_CHECKOUT}
									onLoad={() => {
										const epayco = window.ePayco2.init({
											configure: {
												key: parseJwt(),
												test: true
											}
										});
										this.setState({ epayco });
									}}
								/>
								<Btn
									hg={"35"}
									loading={this.state.loadingR}
									disabled={this.state.loadingR}
									onClick={() => {
										this.handleScriptLoad();
										this.setState({ loadingR: true });
									}}
								>
									Reintentar
								</Btn>
							</Flex>
						)}
						{!this.state.printState && (
							<ShowOptions
								value={this.state.textEmail}
								show={() =>
									this.setState({
										email: !this.state.email
									})
								}
								email={this.state.email}
								loading={this.state.loading}
								loadingEmail={this.state.loadingEmail}
								loadingPayment={this.state.loadingPayment}
								//showPayment={this.state.showPayment}
								isDebit={this.state.isDebit}
								downloadPdf={this.downloadPdf.bind(this)}
								print={this.print.bind(this)}
								onChangeInputText={this.onChangeInputText.bind(this)}
								sendEmail={this.state.isDebit?this.sendEmailDebit.bind(this):this.sendEmail.bind(this)}
								payment={this.payment.bind(this)}
								enviado={this.state.enviado}
								error={
									this.validator.message("email", this.state.textEmail, [
										"required",
										{
											regex:
												'^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
										}
									]) || this.state.error
								}

								payDebit={this.state.responseCheckoutPago && this.state.responseCheckoutPago.x_response}
								isExist={this.state.isExist}
							/>
						)}
						<a hidden id="pdf"></a>
					</div>
				</Mycard>
			</Elastic>
		);
	}
}

export default withRouter(RespuestaSuscripcion);
